export const cacheBusterHeaders = {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: -1
};
